import { createSlice } from '@reduxjs/toolkit'
import { ActionType } from 'typesafe-actions'

const uiSlice = createSlice({
  name: 'ui',
  initialState: {},
  reducers: {
    redirect: {
      reducer: () => {},
      prepare: (path: string) => ({ payload: null, meta: { pushToRoute: path } }),
    },
    reloadRequested: () => {},
  },
})

const { actions: uiEvents } = uiSlice

export type UiEvent = ActionType<typeof uiEvents>

export { uiEvents }
